// extracted by mini-css-extract-plugin
export default {"container":"euBQE","left":"fnk+n","right":"UspTc"};